const zhCN = {
  tabMiniprogSettings: '访客微信小程序设置',

  miniProgSettingsTitle: '访客微信小程序设置',
  uploadBannerTxt: '上传 Banner 图片',
  uploadBannerDesc: '图片格式为png、jpg、gif，大小不超过 200KB，分辨率为 375*200',
  uploadBannerBtn: '上传自定义 Banner 图片',
  uploadBannerBlank: '请上传自定义 Banner 图片！',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',

  realNameTxt: '访客实名制',
  realNameBlank: '请选择访客实名制类型！',

  visitorMustIdTxt: '预约来访人员必填证件号',
  visitorMustIdBlank: '请选择预约来访人员是否必填证件号！',

  defaultAuth: '默认授权',
  defaultAuthDesc: '访客预约成功后，默认给访客授予权限',

  submitMiniProgSetBtn: '提交设置',

  QRCodeApplyDesc: '访客通过微信扫描二维码，进入微信小程序，申请访问！',
  QRCodeH5ApplyDesc: '访客通过浏览器扫描二维码，进入H5网页端，申请访问！',

  getMiniprogSettingsFail: '获取访客微信小程序设置失败！',
  setMiniprogSettingsSuccess: '访客微信小程序设置成功！',
  setMiniprogSettingsFail: '访客微信小程序设置失败！',
  miniprogNameCNTitle: '小程序中文名称',
  miniprogNameENTitle: '小程序英文名称',
  miniprogLogoTitle: '小程序LOGO',
  miniprogOnlyMainVisitorTitle: '仅登记主要人员',
  miniprogOnlyMainVisitorDesc: '开启后同行人员仅登记数量',
  miniprogCompanyStyleTitle: '小程序企业风采',
  miniprogNameCNBlank: '小程序中文名称不能为空！',
  miniprogNameCNPlacehoder: '请输入中文名称！',
  miniprogNameENPlacehoder: '请输入英文名称！',
  uploadCompanyStyleBtn: '上传 企业风采 图片',
  uploadLogoBtn: '上传 小程序LOGO 图片',
  uploadLogoDesc: '图片格式为png、jpg、gif，大小不超过 200KB，推荐分辨率为 144*144',
  uploadCompanyStyleDesc: '图片格式为png、jpg、gif，大小不超过 1024KB',

  miniprogShowPeopleName: '登记显示员工姓名',
  miniprogShowPeopleNameDesc: '开启后访客申请访问时将显示员工姓名',
  miniprogScenePhotoNotEmpty: '现场照不为空',
  miniprogScenePhotoNotEmptyDesc: '关闭后访问申请不会强制要求拍摄现场照',
  miniprogIdNumberNotEmptyDesc: '关闭后访问申请不会强制要求填写身份证号',

  miniprogOpenSmsNotice: '是否开启短信通知',
  miniprogOpenSmsNoticeDesc: '开通后可通过短信通知相关人员，如预约审批、抄送、审核结果等',
}
const enUS = {
  tabMiniprogSettings: 'WeChat Mini-prog of Visitor',

  miniProgSettingsTitle: 'WeChat Mini-prog of Visitor Settings',
  uploadBannerTxt: 'Upload Banner',
  uploadBannerDesc: 'The image format is PNG, JPG or GIF, the size is not more than 200KB, the resolution is 375*200',
  uploadBannerBtn: 'Upload User-defined Banner',
  uploadBannerBlank: 'Please upload user-defined banner!',
  uploadSuccess: 'Upload successful!',
  uploadFail: 'Upload failed!',

  realNameTxt: 'Real Name for Visitors',
  realNameBlank: 'Please select real name type!',

  visitorMustIdTxt: 'Booked visitor\'s ID number must filled',
  visitorMustIdBlank: 'Please choose whether the booked visitor\'s ID number must filled!',

  defaultAuth: 'Default Authorization',
  defaultAuthDesc: 'Authorize after the visitor reservation is successful',

  submitMiniProgSetBtn: 'Submit Settings',

  getMiniprogSettingsFail: 'Get WeChat mini-prog settings failed!',
  setMiniprogSettingsSuccess: 'Submit WeChat mini-prog settings successful!',
  setMiniprogSettingsFail: 'Submit WeChat mini-prog settings failed!',
  QRCodeApplyDesc: 'Visitors can enter the wechat mini program  by scanning the QR code and apply for access!',
  QRCodeH5ApplyDesc: 'Visitors scan the QR code through their browser and enter the H5 web page to apply for access！',
  miniprogNameCNTitle: 'Mini Program Chinese name',
  miniprogNameENTitle: 'Mini Program English name',
  miniprogLogoTitle: 'Mini Program LOGO',
  miniprogCompanyStyleTitle: 'Mini Program Company Style',
  miniprogOnlyMainVisitorTitle: 'Only Main Appointment Visitor',
  miniprogOnlyMainVisitorDesc: 'Only the number of peers visitor after opening',
  miniprogNameCNPlacehoder: 'Please enter an Chinese name！',
  miniprogNameENPlacehoder: 'Please enter an English name！',
  uploadCompanyStyleBtn: 'Upload Company Style picture',
  uploadLogoBtn: 'Upload Mini Program LOGO picture',
  uploadLogoDesc: 'The image format is PNG, JPG or GIF, the size is not more than 200KB, the resolution is 144*144',
  uploadCompanyStyleDesc: 'The image format is PNG, JPG or GIF, the size is not more than 1024KB',
  miniprogShowPeopleName: 'Show People Name',
  miniprogShowPeopleNameDesc: 'The employee name will be displayed when the visitor requests access',
  miniprogScenePhotoNotEmpty: 'Scene Photo Not Empty',
  miniprogScenePhotoNotEmptyDesc: 'Not accessing the application after closure will not force the shooting of scene photos',
  miniprogIdNumberNotEmptyDesc: 'Not accessing the application after closure will not force the shooting of id numbers',

  miniprogOpenSmsNotice: 'Is SMS notification enabled',
  miniprogOpenSmsNoticeDesc: 'After activation, relevant personnel can be notified via SMS, such as appointment approval, CC, review results, etc',
}

export default { zhCN, enUS }
